@if (!appSettings.isMobile()) {
    <div>
        <div class="row mb-3 align-items-end g-2">
            <div class="col-md-3">
                <label class="form-label small text-muted mb-1">Categoría</label>
                <ng-select [items]="categories"
                    bindLabel="label"
                    bindValue="value"
                    placeholder="Todas"
                    [clearable]="true"
                    [(ngModel)]="categoryFilter"
                    (change)="applyFilters()">
                </ng-select>
            </div>
            <div class="col-md-4">
                <label class="form-label small text-muted mb-1">Buscar</label>
                <input type="text" class="form-control" placeholder="Nombre, slug o código"
                    [(ngModel)]="searchText" (ngModelChange)="applyFilters()">
            </div>
            <div class="col-md-5 d-flex justify-content-end">
                <ng-content></ng-content>
            </div>
        </div>

        <div class="table-responsive table-data mb-3">
            <table class="table table-hover table-sm align-middle">
                <thead>
                    <tr>
                        <th role="button" (click)="orderCol('code')">Código</th>
                        <th role="button" (click)="orderCol('slug')">Slug</th>
                        <th role="button" (click)="orderCol('name')">Nombre</th>
                        <th role="button" (click)="orderCol('category')">Categoría</th>
                        <th>Estilo</th>
                        <th>Icono</th>
                        <th role="button" (click)="orderCol('isActive')">Activo</th>
                        <th><i class="fas fa-cog"></i></th>
                    </tr>
                </thead>
                <tbody>
                    @if (isLoading) {
                        @for (i of rows; track $index) {
                            <tr class="tr-custom">
                                @for (c of [1,2,3,4,5,6,7]; track c) {
                                    <td><p class="p-skeleton m-1" style="width: 100%; height: 12px;"></p></td>
                                }
                            </tr>
                        }
                    }

                    @for (status of filteredStatuses; track status.id) {
                        <tr [class.table-active]="selectedId() === status.id">
                            <td>{{ status.code }}</td>
                            <td><code class="small">{{ status.slug }}</code></td>
                            <td>{{ status.name }}</td>
                            <td>
                                <span class="badge"
                                    [class.text-bg-primary]="status.category === 'PROCESS'"
                                    [class.text-bg-secondary]="status.category !== 'PROCESS'">
                                    {{ status.category }}
                                </span>
                            </td>
                            <td>
                                <span class="badge" [ngClass]="status.style || 'border text-muted'">
                                    @if (status.icon) {
                                        <i [class]="status.icon" class="me-1"></i>
                                    }
                                    {{ status.name }}
                                </span>
                            </td>
                            <td>
                                @if (status.icon) {
                                    <i [class]="status.icon + ' text-secondary'"></i>
                                    <small class="text-muted ms-1">{{ status.icon }}</small>
                                } @else {
                                    <span class="text-muted small">—</span>
                                }
                            </td>
                            <td>
                               <input type="checkbox" [checked]="status.isActive" disabled>
                            </td>
                            <td>
                                @if (perm.canCurrent('canUpdate')) {
                                <button class="btn btn-outline-primary btn-xs" (click)="selectStatus(status)" title="Editar">
                                    <i class="fas fa-pencil"></i>
                                </button>
                                }
                            </td>
                        </tr>
                    }
                </tbody>
            </table>

            @if (filteredStatuses?.length === 0 && !isLoading) {
                <div class="m-l-10 mb-2">
                    <em>No hay datos</em>
                </div>
            }
        </div>
    </div>
} @else {
    <app-mobile-footer>
        <input type="search"
               class="form-control mobile-footer-search"
               placeholder="Buscar nombre, slug o código..."
               [(ngModel)]="searchText"
               (ngModelChange)="applyFilters()">
        <button type="button" class="btn btn-outline-secondary btn-sm mobile-footer-filter"
                [class.btn-outline-primary]="categoryFilter !== null"
                (click)="mobileFiltersOpen = true">
            <i class="fas fa-filter me-1"></i>Filtros
            @if (categoryFilter !== null) {
                <span class="badge bg-primary ms-1">1</span>
            }
        </button>
    </app-mobile-footer>
    <app-bottom-sheet [open]="mobileFiltersOpen" title="Filtros" (closed)="mobileFiltersOpen = false">
        <div class="d-flex flex-wrap gap-2 px-3 pb-3">
            <span class="filter-badge"
                  role="button"
                  tabindex="0"
                  [class.active]="categoryFilter === null"
                  (click)="setCategoryFilter(null)">
                Todas
            </span>
            @for (cat of categories; track cat.value) {
                <span class="filter-badge"
                      role="button"
                      tabindex="0"
                      [class.active]="categoryFilter === cat.value"
                      (click)="setCategoryFilter(cat.value)">
                    {{ cat.label }}
                </span>
            }
        </div>
    </app-bottom-sheet>

    <div class="d-flex justify-content-between align-items-center mb-2 px-1">
        <span class="small text-muted fw-bold text-uppercase">
            REGISTROS @if (!isLoading) { ({{ filteredStatuses.length }}) }
        </span>
    </div>

    <div class="mobile-cards-scroll">
        @if (isLoading) {
            @for (i of rows; track $index) {
                <app-list-card [isLoading]="true"></app-list-card>
            }
        } @else {
            @for (status of filteredStatuses; track status.id) {
                <app-list-card
                    [isShortcut]="true"
                    (click)="selectStatus(status)">
                    <div cardTitle class="fw-bold text-dark text-truncate">
                        @if (status.icon) {
                            <i [class]="status.icon + ' me-1 text-secondary'"></i>
                        }
                        {{ status.name }}
                    </div>
                    <div cardBadge>
                        <span class="badge"
                            [class.text-bg-primary]="status.category === 'PROCESS'"
                            [class.text-bg-secondary]="status.category !== 'PROCESS'">
                            {{ status.category }}
                        </span>
                    </div>

                    <div class="row g-1 text-muted small">
                        <div class="col-7">
                            <span class="text-muted">Slug</span>
                            
                        </div>
                        <div class="col-5 text-end">
                            <div><code class="small">{{ status.slug }}</code></div>
                        </div>
                    </div>
                </app-list-card>
            }
        }

        @if (!isLoading && filteredStatuses.length === 0) {
            <div class="card border-0 shadow-sm p-4 text-center my-2">
                <i class="fas fa-tags fa-3x text-muted opacity-50 mb-2"></i>
                <h6 class="text-muted mb-1">Sin estados</h6>
                <small class="text-muted">Ajusta los filtros o crea uno nuevo.</small>
            </div>
        }
    </div>
}
